import IconClose from '@apollo/icons/default/IconClose.svg';
import { forwardRef, useTagStyles } from '@chakra-ui/react';
import React, { ComponentPropsWithoutRef } from 'react';

import { IconButton } from '../IconButton/IconButton';

type TagCloseButtonProps = Omit<
  ComponentPropsWithoutRef<typeof IconButton>,
  'aria-label' | 'size' | 'variant'
>;

export const TagCloseButton = forwardRef<TagCloseButtonProps, 'button'>(
  (props, ref) => {
    const styles = useTagStyles();

    return (
      <IconButton
        {...props}
        variant="hidden"
        size="xs"
        aria-label="close"
        ref={ref}
        __css={styles.closeButton}
      >
        <IconClose />
      </IconButton>
    );
  },
);
